export default __webpack_public_path__ + "b4669eedd2690bd753797df83be17577.png";